import useCountryChecker from "../../../hooks/useCountryChecker";

const CountryItemPermission = ({ children, dontCheckCountry = false }) => {
  const { isNigeria } = useCountryChecker();
  return isNigeria || dontCheckCountry ? children : null;
};
export default CountryItemPermission;
